import { z } from "zod/v4";
import {
	emailLogSchema,
	emailStatsSchema,
	emailTemplateSchema,
	newsletterSubscriberSchema,
	type sendPlayerEmailSchema,
	type sendTestEmailSchema,
	sendTestResultSchema,
} from "../schemas/mailing";
import { fetchApi, fetchText, paginatedSchema } from "./internal";

export type EmailLogFilters = {
	status?: string;
	template?: string;
	q?: string;
	isTest?: boolean;
	limit?: number;
	offset?: number;
};

export type SubscriberListParams = {
	limit?: number;
	offset?: number;
	q?: string;
};

export const mailing = {
	get: (id: string) => fetchApi(`/admin/emails/${id}`, emailLogSchema),
	list: (params?: EmailLogFilters) => {
		const search = new URLSearchParams();
		if (params?.status) search.set("status", params.status);
		if (params?.template) search.set("template", params.template);
		if (params?.q) search.set("q", params.q);
		if (params?.isTest !== undefined) search.set("isTest", String(params.isTest));
		if (params?.limit) search.set("limit", String(params.limit));
		if (params?.offset) search.set("offset", String(params.offset));
		const qs = search.toString();
		return fetchApi(`/admin/emails${qs ? `?${qs}` : ""}`, paginatedSchema(emailLogSchema));
	},
	preview: (key: string, locale: string) =>
		fetchText(`/admin/emails/templates/${key}/preview?locale=${encodeURIComponent(locale)}`),
	sendTest: (data: z.infer<typeof sendTestEmailSchema>) =>
		fetchApi("/admin/emails/tests", sendTestResultSchema, {
			body: JSON.stringify(data),
			method: "POST",
		}),
	sendToPlayer: (data: z.infer<typeof sendPlayerEmailSchema>) =>
		fetchApi("/admin/emails", sendTestResultSchema, {
			body: JSON.stringify(data),
			method: "POST",
		}),
	stats: () => fetchApi("/admin/emails/stats", emailStatsSchema),
	subscribers: (params?: SubscriberListParams) => {
		const search = new URLSearchParams();
		if (params?.q) search.set("q", params.q);
		if (params?.limit) search.set("limit", String(params.limit));
		if (params?.offset) search.set("offset", String(params.offset));
		const qs = search.toString();
		return fetchApi(
			`/admin/subscribers${qs ? `?${qs}` : ""}`,
			paginatedSchema(newsletterSubscriberSchema),
		);
	},
	templates: () => fetchApi("/admin/emails/templates", z.array(emailTemplateSchema)),
};
